module.exports = __webpack_public_path__ + "static/img/working-with-us_2.33db15e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/working-with-us_2.svg
// module id = 0+48
// module chunks = 0